import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCameraGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.327 12.946a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Zm-1.8 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      fill="#2BA168"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.412 3.355 17.07 5.26h3.894a1.2 1.2 0 0 1 1.2 1.2v12.985a1.2 1.2 0 0 1-1.2 1.2H4.035a1.2 1.2 0 0 1-1.2-1.2V6.46a1.2 1.2 0 0 1 1.2-1.2h3.896l1.806-1.905h5.675ZM8.705 7.06l1.806-1.905h4.082L16.25 7.06h4.113v11.785H4.635V7.06h4.07Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgCameraGreen);

export default Memo;
